/* eslint-disable no-unused-vars */
// import core & vendor packages below
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, InputGroup, Form } from 'react-bootstrap';
import React from 'react';

// import style below
import UserAccount from 'components/UserAccount';
import { logout, setIsAuthenticated } from 'reducers/authReducer';
import { removeItem } from 'utils/storage';

import './Topbar.scss';
import { ReactComponent as MenuSVG } from 'assets/svg/menu.svg';
import { ReactComponent as UserSVG } from 'assets/svg/user_circle.svg';
import { ReactComponent as MagnifyingGlassSVG } from 'assets/svg/magnifying_glass.svg';

import Select from 'react-select';
import Links from 'constant/links';

// main component
const Topbar = (props) => {
  const { toggle, onToggle } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logOut = () => {
    // dispatch(logout());
    removeItem('accessToken');

    setTimeout(() => {
      dispatch(logout());
      window.location.href = `/`;
    }, 100);
  };

  const selectPath = (path) => {
    navigate(path);
  };

  const [menuIsOpen, setMenuIsOpen] = React.useState(false);

  return (
    <div className='topbar'>
      <Button onClick={() => onToggle(!toggle)}>
        <MenuSVG />
      </Button>
      <InputGroup>
        <div className='search-container'>
          <Select
            className='select-search'
            menuIsOpen={menuIsOpen}
            menuPlacement='auto'
            menuPosition='fixed'
            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
            onInputChange={(input) => {
              setMenuIsOpen(input);
            }}
            onChange={(search) => selectPath(search.path)}
            isClearable={true}
            options={Links}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.path}
            placeholder={
              <div>
                <MagnifyingGlassSVG width='20' className={'d-inline ml-6'} />
                <span> Search</span>
              </div>
            }
          />
        </div>
      </InputGroup>

      <UserAccount />
    </div>
  );
};

export default Topbar;
